import React from 'react';
import './productMainSubHeader.css';
import { useRecoilValue } from 'recoil';
import { Badge, Label, Image } from '@nooz-optics/nooz-components-lib';
import { IProduct } from '../../../../../../utils/types/contentful';
import { formatContentfulComponentProps } from '../../../../../../utils/globals/index';
import { BuyProductButton } from '../../../../BuyButton/buyProduct';
import {
  productState,
  variantState,
} from '../../../../../../utils/recoil/product';
import { ProductMainVariantDetailsHeaderProductPrice } from '../Header/productMainVariantDetailsHeader';
import { ProductMainColorPickerSlider } from '../ColorPicker/productMainColorPicker';
import { withSuspense } from '../../../../../../utils/hocs/withSuspense';

export interface ProductMainSubHeaderProps {
  product: IProduct;
}

export const ProductMainSubHeader: React.FC<ProductMainSubHeaderProps> =
  withSuspense(({ button, price }) => {
    const product = useRecoilValue(productState);
    const variant = useRecoilValue(variantState);

    const category = product?.categories && product.categories[0];

    return (
      <div className='bg-white w-screen justify-center flex'>
        <div className='w-full bg-white main-wrapper flex justify-between'>
          <div className='w-full py-6 lg:py-3 flex justify-between'>
            <div className='hidden lg:flex items-center'>
              <Label
                {...product?.label}
                lineHeight='tight'
                type='p'
                color={{ classname: 'gray-800' }}
                size='3xl'
                weight='medium'
              />
              {category && (
                <div className='ml-11'>
                  <Badge
                    size='sm'
                    type='white'
                    dotColor={category?.color}
                    label={category?.label}
                  />
                </div>
              )}
              {product?.variants && (
                <div className='relative color-picker-sub-header mx-4'>
                  <ProductMainColorPickerSlider
                    variants={product?.variants}
                    selectedColor={variant?.color}
                  />
                </div>
              )}
            </div>
            <div className='flex justify-between items-center w-full lg:w-auto'>
              <div className='mr-4 w-full lg:w-auto'>{button}</div>
              {price}
            </div>
          </div>
        </div>
      </div>
    );
  }, <></>);
